import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const schoolTypeListApi = createAsyncThunk(
    'auth/schoolTypeList',
    async (requestData, { rejectWithValue }) => {
        try {
            const { type, params } = requestData;
            const response = await AuthAxios.get(apiRoutes.analytics(`${type}`), { params })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const schoolTypeListSlice = createSlice({
    name: 'analytics/schoolTypeList',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(schoolTypeListApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(schoolTypeListApi.fulfilled, (state, action) => {
            state.loading = false
            // state.result = action?.payload?.result
            state.result = dummyData
            state.message = action?.payload?.message
        })
        builder.addCase(schoolTypeListApi.rejected, (state, action) => {
            state.loading = false
            state.result = dummyData
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const schoolTypeListReducer = schoolTypeListSlice.reducer


const dummyData = [
    {
        "id": 1,
        "title": "Private",
        "title_hn": "निजी"
    },
    {
        "id": 2,
        "title": "Government",
        "title_hn": "सरकारी"
    },
    {
        "id": 4,
        "title": "Satya Bharti Schools",
        "title_hn": "सत्य भारती स्कूल"
    }
]